// Traceability Provider - Pattern de sélection du provider
// Basculer entre mock et API réelle via REACT_APP_TRACE_PROVIDER

import * as mockProvider from './mock';
import * as smarttraceProvider from './smarttrace';

// Récupérer le provider depuis les variables d'environnement
const TRACE_PROVIDER = process.env.REACT_APP_TRACE_PROVIDER || 'mock';

/**
 * Sélectionne le provider actif
 * @returns {Object} - Le provider (mock ou smarttrace)
 */
const getProvider = () => {
  switch (TRACE_PROVIDER.toLowerCase()) {
    case 'smarttrace':
    case 'real':
    case 'api':
      return smarttraceProvider;
    case 'mock':
    default:
      return mockProvider;
  }
};

/**
 * Recherche un lot par son code
 * @param {string} code - Le code du lot (ex: OCN-MK-2024-001)
 * @returns {Promise<Object|null>} - Les données du lot ou null si non trouvé
 */
export const getLotByCode = async (code) => {
  const provider = getProvider();
  
  // Si c'est le provider mock, pas besoin d'async
  if (TRACE_PROVIDER === 'mock') {
    return provider.getLotByCode(code);
  }
  
  // Provider API réelle
  return await provider.getLotByCode(code);
};

/**
 * Vérifie si un lot existe
 * @param {string} code - Le code du lot
 * @returns {Promise<boolean>}
 */
export const lotExists = async (code) => {
  const provider = getProvider();
  
  if (TRACE_PROVIDER === 'mock') {
    return provider.lotExists(code);
  }
  
  return await provider.lotExists(code);
};

/**
 * Retourne un exemple de code pour l'interface utilisateur
 * @returns {string}
 */
export const getExampleCode = () => {
  const provider = getProvider();
  return provider.getExampleCode();
};

/**
 * Retourne le nom du provider actif (pour debug/admin)
 * @returns {string}
 */
export const getProviderName = () => TRACE_PROVIDER;

/**
 * Vérifie si le provider mock est actif
 * @returns {boolean}
 */
export const isMockProvider = () => TRACE_PROVIDER === 'mock';

export default {
  getLotByCode,
  lotExists,
  getExampleCode,
  getProviderName,
  isMockProvider
};
